/**
 * Root-relative path of an amazon cover preview image. The backend sends the
 * finished URL (`image_url` / `thumb_url` on cover payloads); a payload
 * without one falls back to the legacy unhashed file name.
 */
export function amazonCoverImagePath(coverId: number, url: string | null | undefined, thumb = false): string {
  if (url) {
    return url
  }
  return `/assets/images/amazon-covers/amazon-cover-${coverId}${thumb ? '-thumb' : ''}.jpg`
}
